<template>
  <a @click="trigger">
    <slot>
      <MIcon name="bags-shopping" class="action-menu-icon" />
      <span class="ml-1 action-menu-text">
        {{ $tc('order') }} {{ $tc('po') }}
      </span>
    </slot>
    <FlotoDrawerForm
      ref="drawer"
      :open="isDrawerOpen"
      @cancel="cancelAction"
      @submit="handleSubmit"
    >
      <template v-slot:header> {{ $tc('order') }} {{ $tc('po') }} </template>
      <MRow>
        <MCol :size="6">
          <FlotoFormItem
            :label="`${$tc('order')} ${$tc('date')}`"
            rules="required|nonzero"
          >
            <FlotoDatePicker
              v-model="formData.orderDate"
              :max-date="purchase.requiredByTime"
              :show-time="false"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
      <FlotoFormItem
        v-model="formData.comments"
        rules="description"
        :label="`${$tc('comment', 2)}`"
        :rows="3"
        :placeholder="$tc('comment', 2)"
        type="textarea"
      />
      <MRow class="my-3">
        <MCol>
          <MCheckbox v-model="notify">
            {{ __tc('notify_vendor') }}
          </MCheckbox>
        </MCol>
      </MRow>
      <template v-if="notify">
        <FlotoFormItem rules="required" :label="`${$tc('send')} ${$tc('to')}`">
          <FlotoTagsPicker
            v-model="formData.manualNotification.emailIds"
            type="email"
          />
        </FlotoFormItem>
        <FlotoFormItem
          v-model="formData.manualNotification.subject"
          :placeholder="$t('subject')"
          :label="$t('subject')"
          rules="required"
        />
        <FlotoFormItem>
          <MCheckbox v-model="formData.manualNotification.resourceAsAttachment">
            {{ `${$tc('add')} ${$tc('po')} ${$tc('as')} ${$tc('attachment')}` }}
          </MCheckbox>
        </FlotoFormItem>
        <FlotoFormItem
          :label="`${$tc('email')} ${$t('content')}`"
          rules="required"
        >
          <div class="inline-block w-full">
            <FlotoRichEditor
              ref="emailContent"
              v-model="formData.manualNotification.emailContent"
              :min-rows="5"
              :max-height="200"
              :affix-toolbar="false"
              :placeholder="`${$tc('email')} ${$t('content')}`"
              :disallowed-extensions="['video']"
            />
          </div>
        </FlotoFormItem>
        <FlotoFormItem :label="$tc('attachment', 2)">
          <FlotoAttachment
            v-model="formData.manualNotification.fileAttachments"
          />
        </FlotoFormItem>
      </template>
      <template v-slot:actions="{ submit, hide, processing }">
        <MButton :loading="processing" @click="submit">
          {{ $t('save') }}
        </MButton>
        <MButton variant="default" class="ml-2" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>
<script>
import { getVendorCatalogApi } from '@modules/asset-management/api/vendor-catalog-api'
import { createOrderPOApi } from '../purchase-api'
export default {
  name: 'OrderPODrawer',
  props: {
    purchase: { type: Object, required: true },
  },
  data() {
    return {
      isDrawerOpen: false,
      formData: {
        manualNotification: {},
      },
      notify: true,
      vendor: {},
    }
  },
  computed: {
    vendorEmail() {
      if (this.purchase.vendorId) {
        return this.vendor.email
      }
      return undefined
    },
  },
  watch: {
    notify: {
      handler(newValue) {
        if (newValue) {
          this.formData = {
            ...this.formData,
            manualNotification: {
              emailIds: [this.vendorEmail].filter(Boolean),
              subject: `${this.purchase.name}: ${this.purchase.displayName}`,
              resourceAsAttachment: true,
            },
          }
        } else {
          this.formData = {
            ...this.formData,
            manualNotification: {},
          }
        }
      },
    },
  },
  methods: {
    getVendor(id) {
      if (this.purchase.vendorId) {
        return getVendorCatalogApi(this.purchase.vendorId).then((data) => {
          this.vendor = data
        })
      }
    },
    trigger() {
      setTimeout(() => {
        this.isDrawerOpen = true
        this.getVendor().then((data) => {
          this.formData = {
            manualNotification: {
              subject: `${this.purchase.name}: ${this.purchase.displayName}`,
              emailIds: [this.vendorEmail].filter(Boolean),
              resourceAsAttachment: true,
            },
          }
        })
      }, 400)
      this.$emit('trigger')
    },
    cancelAction() {
      this.isDrawerOpen = false
    },
    handleSubmit() {
      const requestedData = this.formData
      if (!Object.keys(this.formData.manualNotification).length) {
        delete requestedData.manualNotification
      }
      return createOrderPOApi(requestedData, this.purchase.id).then(() => {
        this.isDrawerOpen = false
        this.$emit('refresh')
      })
    },
  },
}
</script>
